import VoterImage from "../../assets/VoterSync/voter-page.png";
import TransbillBookImage from "../../assets/TransBillbookLaunchPopup/image.png";
import Image1 from "../../assets/products/EcommerseDashboard/Login.png";
import { useNavigate } from "react-router-dom";

const solutions = [
  {
    title: "VoterSync",
    desc: "The Voter Management System ensures efficient, transparent, and secure voter data management.",
    img: VoterImage,
    link: "/products/votersync",
  },
  {
    title: "Ecommerce Dashboard",
    desc: "The E-Commerce Dashboard provides a centralized view of all e-commerce operations, including products, orders, customers, and support tickets.",
    img: Image1,
    link: "/products/ecommersedashboard",
  },
  {
    title: "TransBillBook",
    desc: `Our Transport Billing App automates billing \n and  analytics for faster, accurate, and transparent operations.`,
    img: TransbillBookImage,
    link: "/products/transbillbook",
  },
];

export default function DashBoardsolutions() {
  const navigate = useNavigate();
  return (
    <section className="bg-gray-50 py-16 px-4">
      {/* Header */}
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-center text-[#0D3559] mb-12 relative mt-[-50px]">
          Our Solutions
          <span className="block w-24 h-1 bg-[#0d3559] mx-auto mt-3 rounded-full" />
        </h2>

        <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
          Our solutions are designed to bring efficiency, transparency, and
          reliability to your operations, from voter management to transport
          billing—helping organizations manage data, streamline processes, and
          gain actionable insights with ease
        </p>
      </div>

      {/* Cards */}
      <div className="flex flex-wrap justify-center gap-8">
        {solutions.map((sol, idx) => (
          <div
            key={idx}
            className="max-w-sm w-full bg-white rounded-xl shadow-md overflow-hidden transform transition duration-500 hover:scale-105 hover:shadow-xl hover:border-l-4 hover:border-b-4 hover:border-[#0d3559] border-2 border-[#0d3559]"
          >
            <img
              src={sol.img}
              alt={sol.title}
              className="h-56 w-full object-auto"
            />
            <div className="p-6 text-center">
              <h3 className="text-xl font-bold text-[#0d3559] mb-2">
                {sol.title}
              </h3>
              <p className="text-gray-600 mb-4 whitespace-pre-line">
                {sol.desc}
              </p>
              <button
                onClick={() => navigate(sol.link)}
                className="inline-block px-6 py-2 rounded bg-[#0d3559] text-white font-semibold transition duration-300"
              >
                Know More
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
